import { z } from "zod";
import { apiBuilder, prefixApi } from "@zodios/core";

const literalSchema = z.union([z.string(), z.number(), z.boolean(), z.null()]);
type Literal = z.infer<typeof literalSchema>;
type Json = Literal | { [key: string]: Json } | Json[];
const jsonSchema: z.ZodType<Json> = z.lazy(() => z.union([literalSchema, z.array(jsonSchema), z.record(jsonSchema)]));

export const harvestersApiDefinitions = prefixApi(
  "/api/harvesters",
  apiBuilder({
    alias: "getHarvesters",
    method: "get",
    path: "/",
    status: 200,
    parameters: [
      {
        name: "page",
        type: "Query",
        schema: z.number().optional(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().optional(),
      },
      {
        name: "ordering",
        type: "Query",
        schema: z.string().optional(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().optional(),
      },
      { name: "ad", type: "Query", schema: z.number().int().optional() },
      { name: "sources", type: "Query", schema: z.number().int().optional() },
      { name: "targets", type: "Query", schema: z.number().int().optional() },
      { name: "market_place", type: "Query", schema: z.string().optional() },
    ],
    response: z.object({
      count: z.number(),
      next: z.string().nullable(),
      previous: z.string().nullable(),
      results: z.array(
        z.object({
          id: z.number(),
          name: z.string().nullable(),
          org: z.number().int(),
          sources: z.array(z.number()).nullable(),
          targets: z.array(z.number()).nullable(),
          sources_count: z.number().int(),
          targets_count: z.number().int(),
          created_on: z.string().datetime(),
          updated_on: z.string().datetime(),
          created_by: z.number().int().nullable(),
          updated_by: z.number().int().nullable(),
          is_enabled: z.boolean(),
          role: z.string().nullable(),
          program: z.object({
            id: z.number().int(),
            org: z.number().int(),
            name: z.string(),
            status: z.string(),
            template_type: z.string().nullable(),
            run_cnt: z.number().int(),
            error_reason: z.string().nullable(),
            start_date: z.string().datetime().nullable(),
            end_date: z.string().datetime().nullable(),
            engine: z.string().nullable(),
            spec: jsonSchema,
            ui_state: jsonSchema,
            last_run: z.string().datetime().nullable(),
            last_action: z.string().datetime().nullable(),
            created_on: z.string().datetime(),
            updated_on: z.string().datetime(),
            created_by: z.number().int().nullable(),
            updated_by: z.number().int().nullable(),
          }),
        }),
      ),
    }),
  }).build(),
);
